import { ButtonNormalPrimaryMedium } from '@ferreri/prever-component-lib';
import { LinkWrapper } from '@ferreri/prever-component-lib/nextjs';

import { SETTINGS } from '../../config/settings';

type PlanDetailsGsadminButtonProps = {
  planVersionId?: string | number;
};

export const PlanDetailsGsadminButton = (
  props: PlanDetailsGsadminButtonProps,
) => {
  const isInvalidId =
    props.planVersionId === undefined ||
    props.planVersionId === null ||
    props.planVersionId === '';

  const orderBase = (SETTINGS.public.urlOrderWeb || '').replace(/\/+$/, '');
  const orderUrl = !isInvalidId
    ? `${orderBase}/simulate-order/${encodeURIComponent(
        String(props.planVersionId),
      )}`
    : '#';

  return (
    <LinkWrapper href={orderUrl} isDisabled={isInvalidId}>
      <ButtonNormalPrimaryMedium isDisabled={isInvalidId}>
        Simular agora
      </ButtonNormalPrimaryMedium>
    </LinkWrapper>
  );
};
